var _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6466 5.53516H9.50871C8.89205 5.53516 8.30065 5.78012 7.8646 6.21617C7.42856 6.65221 7.18359 7.24361 7.18359 7.86027V26.4612C7.18359 27.0778 7.42856 27.6692 7.8646 28.1053C8.30065 28.5413 8.89205 28.7863 9.50871 28.7863H23.4594C24.076 28.7863 24.6674 28.5413 25.1035 28.1053C25.5395 27.6692 25.7845 27.0778 25.7845 26.4612V13.6731L17.6466 5.53516Z",
    fill: "url(#paint0_linear_1197_11018)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1197_11018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6465 5.53516V12.6523C17.6465 13.216 18.1035 13.6731 18.6673 13.6731H25.7844",
    fill: "url(#paint1_linear_1197_11018)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70703 13.5732H13.6929",
    stroke: "white",
    strokeWidth: 1.02078,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70703 17.9578H17.2803",
    stroke: "white",
    strokeWidth: 1.02078,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8756 29.4099C24.8756 29.4099 29.5031 27.0961 29.5031 23.6255V19.5764L24.8756 17.8411L20.248 19.5764V23.6255C20.248 27.0961 24.8756 29.4099 24.8756 29.4099Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8756 29.4099C24.8756 29.4099 29.5031 27.0961 29.5031 23.6255V19.5764L24.8756 17.8411L20.248 19.5764V23.6255C20.248 27.0961 24.8756 29.4099 24.8756 29.4099Z",
    fill: "url(#paint2_linear_1197_11018)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3145 22.7751L24.356 24.8167L27.7586 21.4141",
    stroke: "white",
    strokeWidth: 1.02078,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1197_11018",
    x: 16.6257,
    y: 5.1949,
    width: 10.1802,
    height: 10.1795,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.680521
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.510391
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1197_11018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1197_11018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_11018",
    x1: 7.89916,
    y1: 6.78219,
    x2: 26.9018,
    y2: 30.0551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF55F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_11018",
    x1: 17.9595,
    y1: 5.97162,
    x2: 24.1754,
    y2: 15.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF55F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#FF5252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1197_11018",
    x1: 24.8756,
    y1: 17.8411,
    x2: 24.8756,
    y2: 29.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon11);
export default __webpack_public_path__ + "static/media/drive_card_icon11.6b46308acd4ec5ff412439ed17d6e82f.svg";
export { ForwardRef as ReactComponent };